import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgReportIssueOutline = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M5.24 13.175v.193l1.563-1.39.455-.403h5.347c.54 0 .885-.097 1.102-.21.226-.119.376-.27.485-.472.114-.214.208-.542.208-1.048V4.336c0-.508-.095-.831-.206-1.037l-.003-.006a1.1 1.1 0 0 0-.487-.478l-.005-.003c-.214-.114-.556-.212-1.094-.212h-9.21c-.535 0-.881.097-1.104.213a1.1 1.1 0 0 0-.482.48l-.003.006c-.11.206-.206.53-.206 1.037v5.51c0 .5.093.828.205 1.042.118.212.271.364.487.48.225.116.557.207 1.052.207h1.897zm7.365 0q1.09 0 1.842-.39.758-.398 1.156-1.137.397-.746.397-1.803V4.336q0-1.057-.397-1.796a2.7 2.7 0 0 0-1.156-1.142Q13.697 1 12.605 1h-9.21q-1.09 0-1.85.398-.75.398-1.148 1.142Q0 3.28 0 4.336v5.51q0 1.056.397 1.802.405.739 1.149 1.136.75.39 1.798.39h.297v2.06q0 .347.173.553.18.213.513.213.225 0 .419-.114.194-.106.47-.354l2.65-2.357zM7.827 3h.29c.468 0 .842.523.827.912l-.117 3.134c-.015.372-.38.666-.826.666-.447 0-.812-.294-.827-.666L7 3.912c-.016-.39.358-.912.826-.912M7 9.778c0 .556.448 1.008 1 1.008s1-.452 1-1.008C9 9.22 8.552 8.77 8 8.77s-1 .45-1 1.008"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgReportIssueOutline);
export default ForwardRef;
